import React from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import { Container } from 'styles';
import { ColumnContentLarge, ColumnContentSmall } from 'styles/ColumnContent';
import ButtonOutline from 'components/layout/button-outline/ButtonOutline';
import * as S from './styles';

const HelpBlock = () => (
    <Container>
        <S.CustomColumnContent>
            <ColumnContentSmall>
                <S.HelpBlockTitle>Ainda precisa de ajuda?</S.HelpBlockTitle>
            </ColumnContentSmall>

            <ColumnContentLarge>
                <S.HelpBlockText>
                    Confira os artigos que podem te ajudar com as dúvidas mais comuns ou selecione uma sessão para ver mais artigos relacionados. Se ainda precisa de ajuda, nos envie sua dúvida ou solicitação.
                </S.HelpBlockText>

                <Link to="/enviar-duvida">
                    <ButtonOutline label="Enviar dúvida" width={isMobile ? '100%' : '280px'} />
                </Link>
            </ColumnContentLarge>
        </S.CustomColumnContent>
    </Container>
);

export default HelpBlock;